import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import { isEmpty, startCase } from "lodash";

import CustomDatePicker from "../components/CustomDatePicker";
import Pagination from "../components/Pagination";
import { apiGet } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import {
  DownlineHeader,
  formatDate,
  toFixedWithoutRounding,
} from "../Utils/Constant";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const platformOptions = [
  { value: "", label: "All Platforms" },
  { value: "BG", label: "BG" },
  { value: "E1SPORT", label: "E1SPORT" },
  { value: "SV388", label: "SV388" },
  { value: "DRAGOONSOFT", label: "DRAGOONSOFT" },
  { value: "SEXYBCRT", label: "SEXYBCRT" },
  { value: "KINGMAKER", label: "KINGMAKER" },
  { value: "JILI", label: "JILI" },
  { value: "HORSEBOOK", label: "HORSEBOOK" },
  { value: "JDB", label: "JDB" },
  { value: "RT", label: "RT" },
  { value: "PP", label: "PP" },
  { value: "SABA", label: "SABA" },
  { value: "SPADE", label: "SPADE" },
  { value: "YESBINGO", label: "YESBINGO" },
  { value: "YL", label: "YL" },
  { value: "EVOLUTION", label: "EVOLUTION" },
  { value: "BTG", label: "BTG" },
  { value: "NETENT", label: "NETENT" },
  { value: "NLC", label: "NLC" },
  { value: "HOTROAD", label: "HOTROAD" },
  { value: "SPRIBE", label: "SPRIBE" },
  { value: "FC", label: "FC" },
  { value: "SMARTSOFT", label: "SMARTSOFT" },
];

const CasinoBetList = () => {
  const params = useParams();
  const tableRef = useRef();

  const previousDate = moment().subtract(1, "day").format("YYYY-MM-DD");
  const currentDate = moment().format("YYYY-MM-DD");

  const [data, setData] = useState({});
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const DEFAULT_FILTER = {
    type: "3",
    betType: "casino",
    sortOrder: "asc",
    fromPeriod: previousDate,
    toPeriod: currentDate,
    betId: "",
    stake: "",
    platform: "",
    gameName: "",
    limit: 10,
    status: "completed",
    page: 1,
    userType: user?.userType,
    id: user?._id,
  };
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getCasinoNew,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results || {});
    }
  };

  useEffect(() => {
    getData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, filter.limit]);

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  const handleSortChange = (e) =>
    setFilter((prev) => ({ ...prev, status: e.target.value, page: 1 }));
  const handleBetIdChange = (e) =>
    setFilter((prev) => ({ ...prev, betId: e.target.value }));
  const handleStakeChange = (e) =>
    setFilter((prev) => ({ ...prev, stake: e.target.value }));
  const handleGameNameChange = (e) =>
    setFilter((prev) => ({ ...prev, gameName: e.target.value }));
  const handlePlatformChange = (option) =>
    setFilter((prev) => ({
      ...prev,
      platform: option?.value || "",
      page: 1,
    }));
  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const rows = data?.data || [];
  const totalPnl = rows.reduce(
    (sum, item) => sum + Number(item?.playerPL ?? item?.amount ?? 0),
    0,
  );
  const totalStakes = rows.reduce(
    (sum, item) => sum + Number(item?.betAmount || 0),
    0,
  );

  return (
    <app-awc-casino-bets _nghost-serverapp-c87 className="ng-star-inserted">
      <div
        _ngcontent-serverapp-c87
        className="full-wrap"
        style={{ height: "calc(100% - 105px)" }}
      >
        <div _ngcontent-serverapp-c87 className="over-wrap">
          <div _ngcontent-serverapp-c87 className="total_all">
            <span>
              <strong>Casino Bet List</strong>
            </span>
            <div _ngcontent-serverapp-c87 className="spacer" />
            <span className="total-users">
              {" "}
              Total Records: <strong>{data?.totalDocs || 0}</strong>
            </span>
            &nbsp;{" "}
            <span className="total-users">
              {" "}
              Total Pnl:{" "}
              <strong className={totalPnl < 0 ? "loss-text" : "profit-text"}>
                {toFixedWithoutRounding(totalPnl)}{" "}
              </strong>
            </span>
            <span className="total-users">
              {" "}
              Total Stakes:{toFixedWithoutRounding(totalStakes)} <strong />
            </span>
            &nbsp;{" "}
          </div>
          <div _ngcontent-serverapp-c87 className="function-wrap">
            <ul _ngcontent-serverapp-c87 className="input-list contentclass">
              <li>
                <label>Period:</label>
              </li>
              <CustomDatePicker
                type="new"
                filter={filter}
                setFilter={setFilter}
              />
            </ul>
            <ul _ngcontent-serverapp-c87 className="input-list diaplayflex">
              <li>
                <input
                  appinputrestriction="noSpecialChars3"
                  type="text"
                  placeholder="Search Betid"
                  value={filter.betId}
                  onChange={handleBetIdChange}
                />
              </li>
              <li>
                <label>Stake</label>
                <input
                  type="number"
                  name="Volume Check"
                  className="textfield-input"
                  placeholder="Stake"
                  value={filter.stake}
                  onChange={handleStakeChange}
                />
              </li>
              <li>
                <label>Platform: </label>
                <Select
                  options={platformOptions}
                  value={
                    platformOptions.find(
                      (option) => option.value === filter.platform,
                    ) || null
                  }
                  onChange={handlePlatformChange}
                  placeholder="All Platform"
                  isSearchable={true}
                  isClearable={true}
                  className="ng-select ng-select-single ng-select-searchable ng-select-clearable"
                  classNamePrefix="ng"
                />
              </li>
              <li>
                <input
                  type="text"
                  placeholder="Search Game Name"
                  value={filter.gameName}
                  onChange={handleGameNameChange}
                />
              </li>
              <li>
                <label style={{ marginTop: "5px" }}>Limit:</label>
                <select
                  name="limit"
                  id="limit"
                  value={filter.limit}
                  onChange={handleLimitChange}
                >
                  <option value={10}>10 Txn</option>
                  <option value={25}>25 Txn</option>
                  <option value={50}>50 Txn</option>
                  <option value={100}>100 Txn</option>
                </select>
              </li>
              <li>
                <label>Status:</label>
                <select
                  name="status"
                  id="status"
                  value={filter.status}
                  onChange={handleSortChange}
                >
                  <option value="active">Pending</option>
                  <option value="completed">Settled</option>
                </select>
              </li>
              <li>
                <a
                  id="getPL"
                  className="btn-send"
                  onClick={(e) => {
                    e.preventDefault();
                    getData(filter);
                  }}
                >
                  Get History
                </a>
              </li>
            </ul>
          </div>
          <div _ngcontent-serverapp-c87 id="userTreeDiv" className="total_all">
            <div className="spacer" />
          </div>
          <div _ngcontent-serverapp-c87 className="table-responsive data-table">
            <div _ngcontent-serverapp-c86 id="report">
              <table
                ref={tableRef}
                _ngcontent-serverapp-c86
                id="table_DL"
                className="table-s"
                style={{ display: "table" }}
              >
                <tbody _ngcontent-serverapp-c86>
                  <tr>
                    {DownlineHeader(user?.userType)?.map((res) => {
                      return (
                        <th
                          _ngcontent-serverapp-c84
                          width="5%"
                          data-order="asc"
                          data-name="playerId"
                          className="align-L sort_asc ng-star-inserted"
                        >
                          {" "}
                          {res?.value} ID{" "}
                        </th>
                      );
                    })}
                    <th width="5%" className="align-L sort_asc">
                      PL ID{" "}
                    </th>
                    <th width="5%" className="align-L sort_asc">
                      Round Id{" "}
                    </th>
                    <th id="betTime" width="6%" className="align-L sort_asc">
                      Bet taken{" "}
                    </th>
                    <th id="betTime" width="6%" className="align-L sort_asc">
                      Bet Settled{" "}
                    </th>
           
                    <th width="5%" className="align-L sort_asc">
                      Platform{" "}
                    </th>
                    <th width="7%" className="align-L sort_asc">
                      Game Type{" "}
                    </th>
                    <th width="5%" className="sort_asc">
                      {" "}
                      Stake{" "}
                    </th>
                    <th width="5%" className="sort_asc">
                      {" "}
                      Profit/Loss
                    </th>
                    <th width="5%">Status</th>
                  </tr>
                  {rows.length > 0 ? (
                    rows.map((item, index) => {
                      const pl = Number(item?.playerPL ?? item?.amount ?? 0);
                      return (
                        <tr key={item?._id || index}>
                          {DownlineHeader(user?.userType)?.map((res) => {
                            return (
                              <td
                                _ngcontent-serverapp-c119
                                id="agentUserId2"
                                className="align-L ng-star-inserted"
                              >
                                {item[res?.key]?.username || "N/A"}
                              </td>
                            );
                          })}
                          <td id="playerId" className="align-L">
                            {item?.clientName || "-"}
                          </td>
                          <td id="consolidateId" className="align-L">
                            {item?.casinoBetId}
                          </td>
                          <td id="betTime" className="align-L">
                            {formatDate(item?.timeInserted)}
                          </td>{" "}
                          <td id="betTime" className="align-L">
                            {formatDate(item?.timeInserted)}
                          </td>
                          <td id="sportname" className="align-L">
                            {item?.platform}
                          </td>{" "}
                          <td id="eventName" className="align-L">
                            {item?.casinoName}
                          </td>
                          <td id="matchStake">
                            {toFixedWithoutRounding(item?.betAmount || 0)}
                          </td>
                          <td
                            id="profitOrLossTh"
                            className={pl == 0 ? "" : pl < 0 ? "red" : "green"}
                          >
                            <span id="pol" className="small-date">
                              {toFixedWithoutRounding(pl)}
                            </span>
                          </td>
                          <td id="status">
                            {item?.status ? startCase(item.status) : "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={12}>
                        You have no bets in this time period.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {rows.length > 0 && data?.totalDocs > 0 && (
              <Pagination pagination={data} onPageChange={handlePageChange} />
            )}
          </div>
        </div>
      </div>
    </app-awc-casino-bets>
  );
};

export default CasinoBetList;
